import classNames from 'classnames';

import { allCookieSettings } from '../../contexts/ConsentContext';
import BasicButton from '../buttons/BasicButton';
import ToggleButton from '../buttons/ToggleButton';

import styles from '../../styles/forms/cookies-settings-form.module.css';

interface CookiesSettingsFormProps {
    value?: string[];
    className?: string | null;
    onChange?: (newValue: string[] | null) => void | null;
}

function CookiesSettingsForm({
    value,
    onChange = null,
    className = null,
}: CookiesSettingsFormProps) {
    const onToggleChange = (id: string, newValue: boolean) => {
        if (onChange) {
            onChange(
                newValue
                    ? [...(value || []).filter((consentId) => consentId !== id), id]
                    : (value || []).filter((consentId) => consentId !== id),
            );
        }
    };
    return (
        <form className={classNames([styles.container, className])}>
            {allCookieSettings.map(({ id, label, description }) => (
                <div key={id} className={styles.row}>
                    <BasicButton
                        className={styles.label}
                        onClick={() =>
                            onToggleChange(id, !(value !== null && value.indexOf(id) !== -1))
                        }
                    >
                        <h4 className={styles.title}>{label}</h4>
                        <div className={styles.description}>{description}</div>
                    </BasicButton>
                    <ToggleButton
                        value={value !== null && value.indexOf(id) !== -1}
                        onChange={(newValue) => onToggleChange(id, newValue)}
                        className={styles.toggle}
                    />
                </div>
            ))}
        </form>
    );
}

export default CookiesSettingsForm;
